export default __webpack_public_path__ + "static/media/ic_bahamas.35ae8da0.svg";